<template>
  <div class="privacy-policy-page">
    <!-- RECUADRO ROJO CON NAVBAR Y TÍTULO PRINCIPAL -->
    <div class="mx-3 page-header bg-gradient-danger position-relative border-radius-xl header-container">
      <navbar
        is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
        btn-background="bg-gradient-danger"
        :dark-mode="true"
      />
      <div class="container pt-6 pb-6">
        <div class="row">
          <div class="col-12 text-center text-white">
            <h1 class="text-white title mt-4 mb-0">
              Términos y Condiciones y Aviso de Privacidad
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENIDO DE LA PÁGINA (SIN TARJETA BLANCA) -->
    <div class="container mt-4 pb-5">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1 p-4 p-md-5">
          
          <!-- SECCIÓN DE TÉRMINOS Y CONDICIONES -->
          <article class="terms-content text-start">
            <h2 class="h3 fw-bold mb-2 text-danger">TÉRMINOS Y CONDICIONES DE USO DEL SERVICIO VIAJABARA SAS DE C.V</h2>
            
            <p class="text-muted mb-4 small">
              VIAJABARA SAS de C.V. | Última actualización: 29 de octubre de 2024
            </p>

            <hr class="horizontal dark my-4" />

            <p>
              El presente Contrato describe los términos y condiciones generales ("Términos y Condiciones" o "TyC") aplicables al uso de los ofrecidos por VIAJABARA, Sociedad por Acciones Simplificada de Capital Variable o de su abreviatura de SAS de C.V, en adelante: "VIAJABARA" y sus derivados ("La página web"). Cualquier persona que desee acceder y/o usar La página web y sus servicios podrán hacerlo sujetándose a los TyC Generales, junto con todas las demás políticas y principios que rigen a VIAJABARA y que son incorporados al presente por referencia.
            </p>

            <p>
              <strong>PERSONALIDAD, DOMICILIO, DESCRIPCIÓN Y ÁMBITO DEL SERVICIO:</strong> VIAJABARA SAS de C.V, con un capital de 300,000.00 M.X.N y con Folio de constitución SAS2019213420, con domicilio en CALLE LIRIO NÚMERO EXTERIOR 1 NÚMERO INTERIOR SN ENTRE CALLE DALIA Y CALLE MAGNOLIA COLONIA REVOLUCION LOCALIDAD OTRA NO ESPECIFICADA EN EL CATALOGO MUNICIPIO CUERNAVACA ENTIDAD FEDERATIVA MORELOS, pudiendo establecer oficinas, sucursales y agencias en cualquier otra parte de la República Mexicana o en el extranjero, así como estipular domicilios convencionales en los contratos que celebre.
            </p>

            <p>
              Que opera y provee servicios de autotransporte federal de turismo, mismos que serán descritos en el cuerpo de los presentes TyC, a través de medios electrónicos, a través de La página web www.viajabaramexico.com.mx, pone a disposición de los usuarios una plataforma tecnológica para poder hacer uso de un servicio de autotransporte de turismo en vehículos destinados a dicha actividad, de conformidad a lo previsto en la materia y cuerpo del Art. 30 del Reglamento de Autotransporte Federal y servicios auxiliares en vigor. Tal actividad se ejecutará en los caminos y vías de jurisdicción federal, previa autorización y/o permiso que para tales alcances otorgue a la firma del mérito la SCT (Secretaría de Comunicaciones y Transportes) y/o Gobierno local correspondiente.
            </p>

            <div class="alert alert-danger text-white my-4" role="alert">
              <strong>CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES GENERALES, LOS CUALES TIENEN UN CARÁCTER OBLIGATORIOS Y VINCULANTES, DEBERÁ ABSTENERSE DE UTILIZAR LA PÁGINA WEB, APLICACIÓN MOVIL Y/O LOS SERVICIOS. EL USO DEL SERVICO Y LA ACEPTACIÓN A ESTOS TYC TENDRÁ LA MISMA FUERZA LEGAL QUE UNA FIRMA AUTÓGRAFA Y PODRÁ SER ELEGIBLE COMO PRUEBA JUDICIAL EN CASO DE CONTROVERSIA.</strong>
            </div>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">I.- INTRODUCCIÓN, OBJETO Y DE LOS SERVICIOS</h3>
            <p>
              "VIAJABARA", actúa en los ámbitos de la distribución y comercio de bienes y servicios; y es propietaria de una página web en Internet y una aplicación móvil a través de la cual pone determinada información a disposición de sus usuarios. La página web es accesible desde el dominio o dirección de Internet: https://viajabaramexico.com.mx.
            </p>
            <p>
              A través de LA APLICACIÓN MOVIL, VIAJABARA facilita a sus usuarios el acceso y la utilización de diversos servicios y contenidos, entre ellos, el servicio de autotransporte de turismo en vehículos destinados al giro en cuestión (en adelante, los "Servicios") puestos a disposición por VIAJABARA. Tanto el acceso como la utilización general de LA APLICACIÓN MOVIL atribuyen la condición de usuario de esta (en adelante, el "Usuario"), implicando necesariamente la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en los términos y condiciones generales de acceso y uso de esta.
            </p>

            <h4 class="h5 fw-bold mt-3">a) CONSENTIMIENTO Y ACEPTACIÓN DE LOS TYC</h4>
            <p>
              El Usuario acepta y consiente que con navegar y utilizar La página web estará aceptando tácitamente los presentes TyC y manifiesta tácitamente un consentimiento de la voluntad de los TYC, tomando en consideración lo dispuesto por las leyes mexicanas y los tribunales de México. Al Registrarse como Usuario, se está aceptando expresamente el contenido de los Presentes TyC.
            </p>

            <h4 class="h5 fw-bold mt-3">b) DEFINICIONES</h4>
            <ul>
              <li><strong>Adquirir un servicio de viaje:</strong> Realizar un viaje en un trayecto previamente proyectado por La página web ViajaBara o la aplicación móvil, realizando un pago por dicho servicio.</li>
              <li><strong>Condiciones:</strong> Los presentes Términos y Condiciones Generales de uso, incluyendo las Condiciones Particulares.</li>
              <li><strong>Código de Conducta:</strong> Lineamientos de conducta que todo Usuario debe seguir y respetar.</li>
              <li><strong>Conductor:</strong> La persona que conducirá y transportará personas con precaución y cumpliendo el reglamento de tránsito vigente a un destino previamente descrito.</li>
              <li><strong>Cliente:</strong> Persona que ha aceptado una oferta de ser trasladado hacia algún destino por el servicio que ofrece VIAJABARA.</li>
              <li><strong>Seguro:</strong> Contrato de seguro de viajero que cubre los riesgos creados por la conducción de la unidad en caso de sufrir un accidente.</li>
              <li><strong>Trayecto:</strong> Determinado recorrido respecto del cual se ha fijado una cuota a través de LA APLICACIÓN MOVIL.</li>
            </ul>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">II.- NIVELES DE ACCESO Y REGISTRO DE USUARIOS</h3>
            <p>
              La condición de Usuario de VIAJABARA requiere mayoría de edad legal. El Usuario manifiesta y declara contar con al menos 18 años de edad. Al aceptar los términos y condiciones aquí presentes, acuerdas y manifiestas tu consentimiento sobre el hecho que ViajaBara pueda recopilar copias de identificaciones o documentos de identidad que te pertenezcan (incluyendo INE, pasaporte o licencia) para validar la información a través de un proveedor externo.
            </p>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">III.- SISTEMA DE RESERVACIONES</h3>
            <p>
              El Cliente reserva uno o más asientos desde la aplicación al pulsar el botón "Reservar asiento" y pagar el importe correspondiente. El costo del viaje deberá ser cubierto de forma anticipada en la modalidad prepago, ya sea con tarjeta de crédito o débito.
            </p>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">IV.- OBLIGACIONES DEL USUARIO</h3>
            <p>
              El Usuario se obliga a garantizar la veracidad de los datos de registro, custodiar sus credenciales de acceso, notificar sobre cualquier uso indebido o fallo de seguridad y comportarse de forma educada y razonable durante el traslado.
            </p>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">V.- NORMAS DE BUENA CONDUCTA</h3>
            <p>
              No se permite el consumo de tabaco, alcohol o sustancias estupefacientes, ni el traslado de mascotas. El equipaje permitido deberá ser pequeño o de mano para garantizar la comodidad y seguridad de todos los pasajeros. Queda strictly prohibido transportar armas o sustancias ilícitas.
            </p>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">VI.- DERECHOS DE AUTOR Y PROPIEDAD INTELECTUAL</h3>
            <p>
              El Contenido de la Página y Aplicación no puede ser copiado, reproducido, republicado, transmitido o distribuido por ningún medio sin la autorización explícita y por escrito de VIAJABARA.
            </p>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">VII.- EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD</h3>
            <p>
              El servicio cuenta con un seguro civil de viajero por 3,160 UMA por persona de acuerdo con lo que establece la Secretaría de Comunicaciones y Transportes (SCT).
            </p>

            <h3 class="h4 fw-bold mt-4 mb-3 text-secondary">VIII.- LEY APLICABLE Y FUERO</h3>
            <p>
              Los presentes Términos y Condiciones se regirán e interpretarán por las Leyes Mexicanas. Ambas partes acuerdan someterse a la jurisdicción de los Juzgados y Tribunales de la Ciudad de México.
            </p>
          </article>

          <hr class="horizontal dark my-5" />

          <!-- SECCIÓN DE AVISO DE PRIVACIDAD -->
          <article class="privacy-content text-start">
            <h2 class="h3 fw-bold mb-3 text-danger">AVISO DE PRIVACIDAD VIAJABARA SAS DE C.V</h2>
            <p>
              El presente Aviso de Privacidad observa los principios de licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad establecidos en la Ley Federal de Protección de Datos Personales en Posesión de Particulares (LFPDPPP).
            </p>

            <h4 class="h5 fw-bold mt-3">1. Aceptación y Datos Personales</h4>
            <p>
              Al proporcionar sus datos personales a VIAJABARA SAS de C.V., el usuario acepta que su información (nombre, domicilio, teléfono, correo electrónico, datos de pago y facturación) sea recabada, almacenada y tratada para la prestación del servicio y fines comerciales o promocionales conexos.
            </p>

            <h4 class="h5 fw-bold mt-3">2. Uso de Datos</h4>
            <p>
              VIAJABARA utilizará sus datos personales para: identificarle y contactarle, cumplir con las obligaciones del servicio, iniciativas de mercadotecnia, validación de identidades mediante proveedores externos, encuestas de calidad e investigaciones estadísticas internas.
            </p>

            <h4 class="h5 fw-bold mt-3">3. Derechos ARCO</h4>
            <p>
              Usted tiene derecho a conocer qué datos personales tenemos (Acceso), solicitar la corrección de su información (Rectificación), que la misma sea eliminada de nuestras bases de datos (Cancelación) u oponerse al uso de los mismos para fines específicos (Oposición). Para ejercer estos derechos, envíe una solicitud al correo electrónico: <strong>viajabara.mexico@gmail.com</strong>.
            </p>

            <h4 class="h5 fw-bold mt-3">4. Contacto</h4>
            <p class="mb-0"><strong>Razón Social:</strong> ViajaBara SAS de C.V.</p>
            <p class="mb-0"><strong>Sitio Web:</strong> www.viajabaramexico.com.mx</p>
            <p><strong>Correo Electrónico de Atención:</strong> viajabara.mexico@gmail.com</p>
          </article>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <footer class="container-fluid bg-gradient-danger mt-5" id="contacto">
      <div class="row py-3">
        <div class="col-12 text-center text-white">
          <router-link to="/" class="text-white fw-bold text-decoration-none" style="font-size: 1.5em">
            <img :src="bus" class="me-2" alt="ViajaBara Logo" />
            ViajaBara
          </router-link>
        </div>
        <div class="col-12 text-center text-white">
          <span style="font-family: 'monserrat'; font-size: 1.2em">
            Viaja sencillo, barato y de volada.
          </span>
        </div>
        <div class="col-12 mt-3 text-center">
          <a
            href="https://www.instagram.com/viajabara_mexico?utm_source=qr"
            target="_blank"
            rel="noopener"
            class="text-secondary ms-4 me-4"
          >
            <span class="fab fa-instagram text-white" style="font-size: 2.5em"></span>
          </a>
          <a
            href="https://www.facebook.com/share/1H83zHcv9n/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener"
            class="text-secondary me-4"
          >
            <span class="fab fa-facebook text-white" style="font-size: 2.5em"></span>
          </a>
          <a
            href="https://wa.me/527773892248"
            target="_blank"
            rel="noopener"
            class="text-secondary me-4"
          >
            <span class="fab fa-whatsapp text-white" style="font-size: 2.5em"></span>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import bus from "@/assets/img/bus-footer.png";

export default {
  name: "PoliticaDePrivacidad",
  components: {
    Navbar,
  },
  data() {
    return {
      bus,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.state.showSidenav = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = false;
  },
  beforeUnmount() {
    this.$store.state.showSidenav = true;
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
  },
};
</script>

<style scoped>
.privacy-policy-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.header-container {
  min-height: 250px;
}

.title {
  font-size: 1.8rem;
  font-family: 'Parisienne', cursive;
  font-style: italic;
  line-height: 1.3;
}

@media (min-width: 576px) { 
  .title {
    font-size: 2.2rem;
  }
}

@media (min-width: 768px) { 
  .title {
    font-size: 2.5rem;
  }
}

@media (min-width: 992px) { 
  .title {
    font-size: 2.8rem;
  }
}

p, li {
  color: #495057;
  line-height: 1.7;
}

ul {
  padding-left: 1.25rem;
}

li {
  margin-bottom: 0.5rem;
}
</style>